<ng-container>
    <button
        *ngIf="isNewUI; else defaultBtn"
        [matMenuTriggerFor]="shortcutsMenu"
        #matRegionsMenuTrigger="matMenuTrigger"
        (click)="openShortcutsMenu()"
        class="!w-auto !p-0 !m-0 !bg-transparent !border-none cursor-pointer inline-flex items-center leading-none text-graniteGray gap-0.5"
        stop-propagation>
        <lucide-icon
            [name]="showSettingIcon ? 'settings' : 'ellipsis-vertical'"
            [size]="14"
            [strokeWidth]="2.2"
            class="inline-flex items-center"></lucide-icon>
        <lucide-icon
            *ngIf="showSettingIcon"
            name="chevron-down"
            [size]="12"
            [strokeWidth]="2.2"
            class="inline-flex items-center"></lucide-icon>
    </button>
    <ng-template #defaultBtn>
        <material-button
            [buttonType]="'icon'"
            [prefixIconAppearance]="'filled'"
            [hideRipple]="true"
            [size]="'small'"
            [classList]="['menuButton', '!text-current', '!w-auto', '!p-0']"
            class="!m-0"
            [matMenuTriggerFor]="shortcutsMenu"
            #matRegionsMenuTrigger="matMenuTrigger"
            (buttonClicked)="openShortcutsMenu()"
            [prefixIcon]="showSettingIcon ? (isNewUI ? 'settings' : 'more_vert') : 'more_vert'"
            [prefixIconType]="'material'"
            [suffixIcon]="isNewUI && showSettingIcon ? 'arrow_drop_down' : ''"
            [prefixIconClassList]="[customIconColor]"
            [suffixIconType]="'material'"
            stop-propagation></material-button>
    </ng-template>
    <mat-menu
        #shortcutsMenu="matMenu"
        [overlapTrigger]="false"
        [class]="
            'shortcutMenu !bg-white !max-h-[calc(100vh-48px)] !min-h-[64px] border-t-2 border-[#00a651] ' +
            (!showSettingIcon ? '' : 'menuClass')
        ">
        <ng-container *transloco="let translate">
            <ng-container *ngIf="shortCutItems.length; else noLength">
                <ng-container *ngFor="let shortCutItem of shortCutItems; trackBy: MenuTrackby">
                    <ng-container [ngSwitch]="shortCutItem.itemName">
                        <ng-container *ngSwitchCase="'All Processes'">
                            <button
                                class="!text-[#000000c9] hover:!bg-[#0000000a]"
                                mat-menu-item
                                (click)="selectionEvent('All Processes')"
                                [title]="translate(shortCutItem.itemName)">
                                <mat-icon class="!text-[#0000008a]" [textContent]="shortCutItem.icon"></mat-icon>
                                <span [textContent]="translate(shortCutItem.itemName)"></span>
                            </button>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Process Now'">
                            <button
                                class="!text-[#000000c9] hover:!bg-[#0000000a]"
                                mat-menu-item
                                (click)="selectionEvent('Process Now')"
                                [title]="translate(shortCutItem.itemName)">
                                <mat-icon class="!text-[#0000008a]" [textContent]="shortCutItem.icon"></mat-icon>
                                <span [textContent]="translate(shortCutItem.itemName)"></span>
                            </button>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Unsubscribe'">
                            <button
                                class="!text-[#000000c9] hover:!bg-[#0000000a]"
                                mat-menu-item
                                (click)="selectionEvent('Unsubscribe')"
                                [title]="translate(shortCutItem.itemName)">
                                <mat-icon class="!text-[#0000008a]" [textContent]="shortCutItem.icon"></mat-icon>
                                <span [textContent]="translate(shortCutItem.itemName)"></span>
                            </button>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <button
                                class="!text-[#000000c9] hover:!bg-[#0000000a]"
                                mat-menu-item
                                [routerLink]="shortCutItem.navigateTo"
                                (click)="selectedItem()"
                                [title]="translate(shortCutItem.itemName)">
                                <mat-icon class="!text-[#0000008a]" [textContent]="shortCutItem.icon"></mat-icon>
                                <span [textContent]="translate(shortCutItem.itemName)"></span>
                            </button>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-template #noLength>
                <mat-progress-bar mode="query"></mat-progress-bar>
            </ng-template>
        </ng-container>
    </mat-menu>
</ng-container>
